import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "leading-none" }

import Pill from "@/Components/General/Pill.vue";
import User from "@/types/User";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserPill',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Pill, { color: "accent" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "before"),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.user.firstname + " " + _ctx.user.lastname), 1),
        _renderSlot(_ctx.$slots, "after")
      ])
    ]),
    _: 3
  }))
}
}

})